import Backbone from 'backbone'
// import Logger from 'Logger'
import _ from 'underscore'

import tpl from './classFilter.mustache'

export var ClassFilterView = Backbone.View.extend({
  tagName: 'div',
  className: 'poker-mall-pclass__filter',
  template: tpl,
  events: {
    'click .poker-mall-filter>a': 'priceFilterHandler',
  },
  initialize: function (options) {
    if (_.isFunction(options.resetSelected)) {
      this.resetSelected = options.resetSelected
    }
  },
  priceFilterHandler: function (event) {
    event.preventDefault()
    var $target = $(event.currentTarget)
    var filterName = $target
      .siblings()
      .removeClass('on')
      .end()
      .addClass('on')
      .data('filter')

    $('[data-visible]')
      .show()
      .each(function () {
        var $this = $(this)
        $this.data('visible') === filterName ? $this.show() : $this.hide()
      })
  },
  detailPopupData: function (filterPrice) {
    var data = this.collection.findWhere({ goods_price: filterPrice }).toJSON()
    return {
      template: 'goodsDetail',
      title: data.goods_disp_name || '',
      message: data.detail_descr || '',
      detailImgUrl: data.detail_img_url || '',
      detail: data.goods_descr_2,
    }
  },
  render: function () {
    var rendered = this.template.render()
    this.$el.empty().append(rendered)
    return this
  },
})
